export default "__VITE_ASSET__3a0ec62d__"